import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomerAgentIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "none",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsxs("g", {
      "clip-path": "url(#clip0_7958_17350)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.8574 9.14258C19.2754 9.14258 22.8574 5.56058 22.8574 1.14258C22.8574 5.56058 26.4394 9.14258 30.8574 9.14258C26.4394 9.14258 22.8574 12.7246 22.8574 17.1426C22.8574 12.7246 19.2754 9.14258 14.8574 9.14258Z",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "2.286",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.5717 14.8567V19.4277C28.5717 20.6897 27.5487 21.7137 26.2857 21.7137H10.2867L3.42969 28.5707V5.71373C3.42969 4.45173 4.45269 3.42773 5.71569 3.42773H17.1447",
        stroke: "currentColor",
        "stroke-width": "2.286",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7958_17350",
        children: /*#__PURE__*/_jsx("rect", {
          width: "32",
          height: "32",
          fill: "white"
        })
      })
    })]
  });
};
export default CustomerAgentIcon;